export const constants = {
  'Buy hair removial at Vialaser online store An easier way to get your best hair removal package for the best price':
    'Compre depilação a laser na loja online da Vialaser. Um jeito ainda mais fácil de adquirir o seu melhor pacote de depilação com o melhor preço.',
  'hair removal, buy hair removal, hair removal price':
    'depilação a laser, comprar depilação a laser, depilação a laser preço',
};
